// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  margin-top: 3rem;
  background: var(--bg-primary);
}

.footer-container {
  max-width: var(--page-max);
  margin: 0 auto;
  padding: 0 1.5rem 2rem;
}

/* Lünetten-Skala als obere Kante */
.footer-scale {
  height: 14px;
  margin-bottom: 2rem;
  opacity: 0.7;
  background:
    repeating-linear-gradient(90deg, var(--border-secondary) 0 1px, transparent 1px 8px) bottom / 100% 6px no-repeat,
    repeating-linear-gradient(90deg, var(--text-tertiary) 0 2px, transparent 2px 40px) bottom / 100% 12px no-repeat;
}

.footer-content {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) repeat(3, minmax(0, 1fr));
  gap: 2rem;
}

.footer-brand {
  display: grid;
  gap: 0.6rem;
  align-content: start;
}

.footer-brand p {
  margin: 0;
  max-width: 22rem;
  font-size: 0.92rem;
}

.footer-logo {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--text-primary);
  font-family: var(--font-display);
  font-size: 1.25rem;
  font-weight: 700;
  text-transform: uppercase;
}

.footer-logo:hover {
  color: var(--text-primary);
}

.footer-logo-img {
  width: 32px;
  height: 32px;
}


.footer-col ul {
  display: grid;
  gap: 0.35rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.footer-col a {
  color: var(--text-secondary);
  font-size: 0.92rem;
}

.footer-col a:hover {
  color: var(--accent-primary);
}

.footer-social {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
}

.footer-bottom {
  margin: 2.25rem 0 0;
  padding-top: 1rem;
  border-top: 1px solid var(--border-primary);
  font-family: var(--font-mono);
  font-size: 0.72rem;
  letter-spacing: 0.04em;
  color: var(--text-tertiary);
}

@media (max-width: 820px) {
  .footer-content {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .footer-brand {
    grid-column: 1 / -1;
  }
}

@media (max-width: 680px) {
  .footer-container {
    padding: 0 1rem 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,sBAAsB;AACxB;;AAEA,mCAAmC;AACnC;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ;;mHAEiH;AACnH;;AAEA;EACE,aAAa;EACb,iEAAiE;EACjE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,0BAA0B;EAC1B,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;;AAGA;EACE,aAAa;EACb,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,2CAA2C;EAC3C,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".footer {\n  margin-top: 3rem;\n  background: var(--bg-primary);\n}\n\n.footer-container {\n  max-width: var(--page-max);\n  margin: 0 auto;\n  padding: 0 1.5rem 2rem;\n}\n\n/* Lünetten-Skala als obere Kante */\n.footer-scale {\n  height: 14px;\n  margin-bottom: 2rem;\n  opacity: 0.7;\n  background:\n    repeating-linear-gradient(90deg, var(--border-secondary) 0 1px, transparent 1px 8px) bottom / 100% 6px no-repeat,\n    repeating-linear-gradient(90deg, var(--text-tertiary) 0 2px, transparent 2px 40px) bottom / 100% 12px no-repeat;\n}\n\n.footer-content {\n  display: grid;\n  grid-template-columns: minmax(0, 1.4fr) repeat(3, minmax(0, 1fr));\n  gap: 2rem;\n}\n\n.footer-brand {\n  display: grid;\n  gap: 0.6rem;\n  align-content: start;\n}\n\n.footer-brand p {\n  margin: 0;\n  max-width: 22rem;\n  font-size: 0.92rem;\n}\n\n.footer-logo {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: var(--text-primary);\n  font-family: var(--font-display);\n  font-size: 1.25rem;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.footer-logo:hover {\n  color: var(--text-primary);\n}\n\n.footer-logo-img {\n  width: 32px;\n  height: 32px;\n}\n\n\n.footer-col ul {\n  display: grid;\n  gap: 0.35rem;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.footer-col a {\n  color: var(--text-secondary);\n  font-size: 0.92rem;\n}\n\n.footer-col a:hover {\n  color: var(--accent-primary);\n}\n\n.footer-social {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n}\n\n.footer-bottom {\n  margin: 2.25rem 0 0;\n  padding-top: 1rem;\n  border-top: 1px solid var(--border-primary);\n  font-family: var(--font-mono);\n  font-size: 0.72rem;\n  letter-spacing: 0.04em;\n  color: var(--text-tertiary);\n}\n\n@media (max-width: 820px) {\n  .footer-content {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .footer-brand {\n    grid-column: 1 / -1;\n  }\n}\n\n@media (max-width: 680px) {\n  .footer-container {\n    padding: 0 1rem 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
